import { useQuery } from "@tanstack/react-query";

import { getAuthUserinfo } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const USER_INFO_QUERY_KEY = "USER_INFO_QUERY_KEY";
const USER_INFO_STALE_TIME = 30 * 1000;

export function useUserInfoQuery() {
  return useQuery({
    queryKey: [USER_INFO_QUERY_KEY],
    queryFn: processResponse(() => getAuthUserinfo()),
    staleTime: USER_INFO_STALE_TIME,
    retry: false,
  });
}
